module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/writable-browser.js
// module id = ./node_modules/readable-stream/writable-browser.js
// module chunks = 5